const initialState = {
    errorList: []
  }
  
  export default function apiErrorReducer(state = initialState, action) {
    switch (action.type) {
      case 'SET_API_ERROR_LIST':
        return {
            ...state,
            errorList: [...state.errorList, action.error]
        }
      default:
        return state;
    }
  }
  